import {styled} from '@mui/material'
import {Texts} from 'appearance'
import {useI18n} from 'store/Store'
import EditIcon from '@mui/icons-material/Edit'
import Button from 'components/Control/Button'

const EditPaymentType = ({user, toggleEditCreditCard}) => {
    const {i18n} = useI18n()

    // const addDashes = (str) => {
    //     const chunkSize = 4
    //     const arrays = []
    //     const ccNumber = str.trim()
    //     for (let i = 0; i < ccNumber.length; i += chunkSize) {
    //         const chunk = ccNumber.slice(i, i + chunkSize)
    //         arrays.push(chunk)
    //     }

    //     return arrays.join('-')
    // }

    return (
        <Container>
            <CcNumberContainer>
                <Title>{i18n.t('settings.ccNumber')}</Title>
                <Texts.RegularText>{user.plannerMaskedPan}</Texts.RegularText>
            </CcNumberContainer>

            <ButtonContainer>
                <Button
                    color="secondary"
                    startIcon={<EditIcon />}
                    onClick={toggleEditCreditCard}>
                    {i18n.t('settings.editPaymentDetails')}
                </Button>
            </ButtonContainer>
        </Container>
    )
}

export default EditPaymentType

const Container = styled('div')`
    width: 100%;
    height: 100%;
    background: #cbddee33;
    padding: 24px;
    display: flex;
    flex-direction: column;
    min-height: 25vh;
    justify-content: space-between;
`
const Title = styled(Texts.RegularText)`
    color: #85898c;
`

const CcNumberContainer = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 8px;
`

const ButtonContainer = styled('div')`
    display: flex;
    justify-content: flex-end;
`
